import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, Renderer2, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Subject, ReplaySubject } from 'rxjs';
import { PhxGutter, PhxAlign, PhxJustify } from './phx-grid.types';

@Component({
  selector: '[phx-row],phx-row',
  exportAs: 'phxRow',
  template: '<ng-content></ng-content>',
  styleUrls: ['./styles/phx-grid.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'phx-row',
    '[class.phx-row-top]': `phxAlign === 'top'`,
    '[class.phx-row-middle]': `phxAlign === 'middle'`,
    '[class.phx-row-bottom]': `phxAlign === 'bottom'`,
    '[class.phx-row-start]': `phxJustify === 'start'`,
    '[class.phx-row-end]': `phxJustify === 'end'`,
    '[class.phx-row-center]': `phxJustify === 'center'`,
    '[class.phx-row-space-around]': `phxJustify === 'space-around'`,
    '[class.phx-row-space-between]': `phxJustify === 'space-between'`,
  },
})
export class PhxRowComponent implements OnInit, OnChanges, OnDestroy {
  @Input() phxAlign: PhxAlign;
  @Input() phxJustify: PhxJustify;
  @Input() phxGutter: PhxGutter;

  private readonly _destroy$: Subject<void> = new Subject<void>();
  public readonly actualGutter$ = new ReplaySubject<[number, number]>(1);

  constructor(private _elemRef: ElementRef, private _renderer: Renderer2) {}

  public ngOnInit(): void {
    this.setGutterStyle();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.phxGutter) {
      this.setGutterStyle();
    }
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  private getGutter(): [number, number] {
    const results: [number, number] = [null, null];
    const gutter = this.phxGutter || 0;
    const normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, gutter];
    normalizedGutter.forEach((g, index) => {
      results[index] = g || null;
    });
    return results;
  }

  private setGutterStyle(): void {
    const [horizontalGutter, verticalGutter] = this.getGutter();
    this.actualGutter$.next([horizontalGutter, verticalGutter]);
    const renderGutter = (name: string, gutter: number | null) => {
      const nativeElement = this._elemRef.nativeElement;
      if (gutter !== null) {
        this._renderer.setStyle(nativeElement, name, `-${gutter / 2}px`);
      }
    };
    renderGutter('margin-left', horizontalGutter);
    renderGutter('margin-right', horizontalGutter);
    renderGutter('margin-top', verticalGutter);
    renderGutter('margin-bottom', verticalGutter);
  }
}
